import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { IOpenGym } from "../../../models/OpenGym";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { OpenGymService } from "../../../services/open-gym.service";

type UseGetOpenGymsRangeArgs = {
  gymId: string;
  date?: string;
  userId?: string;
};

export const useGetOpenGymsByDateAndGymIdQuery = ({
  gymId,
  date = dayjs().format("YYYY-MM-DD"),
  userId,
}: UseGetOpenGymsRangeArgs) => {
  return useQuery<IOpenGym[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_OPEN_GYMS_BY_DATE_AND_GYM_ID, gymId, date, userId],
    enabled: Boolean(gymId),
    queryFn: () =>
      OpenGymService.getOpenGymsByDateAndGymId(
        gymId,
        dayjs(date).format("YYYY-MM-DD"),
        userId
      ).then((res) => res.data),
    staleTime: 60_000,
  });
};
